import { CANDIDATE_DECLARATION } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeCandidateDeclaration } from "lib/serializers/candidateDeclaration";

const createReducer = apiModelOfflineFetchReducer(CANDIDATE_DECLARATION, {
  deserializer: deserializeCandidateDeclaration,
  clearOnRequest: true,
});

export default createReducer;
